module.exports = __webpack_public_path__ + "img/Brochure-The-Lofts-BIG.eb1af0a8.jpg";